import { Button, CloseIcon } from "@src/components/elements";
import { ArrowIcon } from "@src/components/elements/assets/ArrowIcon";
import { DocumentPreview } from "@src/components/modules/DocumentForm/DocumentPreview";
import { useDocumentPreview } from "@src/components/modules/DocumentManager/useDocumentPreview";
import { generatePath, Page } from "@src/shared/pages";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";

const StyledRoot = styled.div<{ flush?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  header {
    padding: 1rem;
    border-bottom: 1px solid var(--border-gray);
    flex-grow: 0;
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;

    h3 {
      margin: 0;
      padding: 0;
      flex-grow: 1;
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: ${({ flush }) => (flush ? "0" : "1rem 1rem 0 1rem")};

    .title {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      text-overflow: ellipsis;
      word-break: break-word;
    }
  }
`;

export const DocumentPreviewPanel: React.FC<{
  documentId: string;
  onClickClose?: () => void;
  className?: string;
  hideEditButton?: boolean;
  hideTitle?: boolean;
  flush?: boolean;
}> = ({
  documentId,
  onClickClose,
  className,
  hideEditButton,
  hideTitle,
  flush,
}) => {
  const { previewUrl, document } = useDocumentPreview(documentId);

  if (!previewUrl || !document) {
    return null;
  }

  return (
    <StyledRoot className={className} flush={flush}>
      {!!onClickClose ? (
        <header>
          <h3>Document preview</h3>
          <CloseIcon onClick={onClickClose} />
        </header>
      ) : null}
      <div className="body">
        {!hideTitle && !hideEditButton ? (
          <div className="row spread margin-bottom xl">
            {!hideTitle ? (
              <Link
                className="title"
                to={generatePath(Page.DOCUMENT_DETAILS, { documentId })}
                target="_blank"
                rel="noopener noreferrer"
              >
                {document.displayName}
                <ArrowIcon />
              </Link>
            ) : null}
            {!hideEditButton ? (
              <Link
                to={generatePath(Page.EDIT_DOCUMENT, { documentId })}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="tertiary">Edit</Button>
              </Link>
            ) : null}
          </div>
        ) : null}
        <DocumentPreview
          document={{
            mimeType: document.mimeType,
            signedDownloadUrl: previewUrl,
          }}
        />
      </div>
    </StyledRoot>
  );
};
